var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var ScreenSeparator = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  margin: 30px 0 30px 0;\n"], ["\n  border: 1px solid ", ";\n  margin: 30px 0 30px 0;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.brandWhite.medium;
});
var templateObject_1;
